module.exports = __webpack_public_path__ + "MagnetWeeb.webp?ddb1bfacad94b8de7d3681e7d2889891";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/MagnetWeeb.webp
// module id = 134
// module chunks = 0